import React, {useEffect, useState} from 'react';
import VideoSection from './VideoSection';
import {useRsvp} from '../context/RsvpContext';
import {useNavigate} from 'react-router-dom';
import CodeEntrySection from "./CodeEntrySection";
import VideoPlaceholder from "./VideoPlaceholder";

const CodeGate: React.FC = () => {
    const {rsvp} = useRsvp();
    const navigate = useNavigate();
    const [isVideoPlaying, setIsVideoPlaying] = useState(false);

    const isMobile = /Mobi/i.test(window.navigator.userAgent);
    const posterImage = isMobile ? "/Welcome-mobile.jpg" : "images/Welcome2.jpg";

    useEffect(() => {
        if (rsvp) {
            navigate('/home', {replace: true});
        }
    }, [rsvp, navigate]);
    
    if (rsvp) return null;

    return (
        <div className="min-h-screen relative">
            <VideoSection
                videoSrc="/Adventure-E&E.mp4"
                posterImage={posterImage}
                onPlayStateChange={setIsVideoPlaying}
                requestFullscreenOnMobile={true}
            >
                <VideoPlaceholder />
            </VideoSection>
            {!isVideoPlaying && (
                <img className="nuestra-boda" src={'images/NuestraBoda.png'} alt={'Nuestra Boda'}/>
            )}
            <CodeEntrySection/>
        </div>
    );
};

export default CodeGate;
